import Vue from 'vue'
import Router from 'vue-router'
import * as auth from './utils/auth'

// Components
import DefaultLayout from './layout/DefaultLayout'
import LoginPage from './auth/LoginPage'
import DashboardPage from './dashboard/DashboardPage'
import OrdersPage from './orders/OrdersPage'
import RefundsPage from './refunds/RefundsPage'
import ProductsPage from './products/ProductsPage'
import UsersPage from './users/UsersPage'
import SettingsPage from './settings/SettingsPage'
import SalesChannelsPage from './sales-channels/SalesChannelsPage'
import DropshipmentPage from './dropshipment/DropshipmentPage'
import PickOrdersPage from './orders/PickOrdersPage'
import ReportProductsPage from './reports/ReportProductsPage'
import RevenueReportPage from './reports/RevenueReportPage'
import ReportProfitMargin from './reports/ReportProfitMarginPage'
import HourRegistrationPage from './employees/HourRegistrationPage'
import PurchaseValuesOrders from './reports/PurchasingValuesOrdersPage'
import OrderListPage from './order-lists/OrderListPage'
import UnknownProductsPage from './products/UnknownProductsPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      beforeEnter: rejectIfAuthenticated
    },
    {
      path: '/',
      component: DefaultLayout,
      beforeEnter: rejectIfNotAuthenticated,
      children: [
        { path: '/', name: 'dashboard', component: DashboardPage },
        { path: '/bestellingen', name: 'orders', component: OrdersPage },
        { path: '/bestellingen/pick', name: 'pick-orders', component: PickOrdersPage },
        { path: '/producten', name: 'products', component: ProductsPage },
        { path: '/retouren', name: 'refunds', component: RefundsPage },
        { path: '/gebruikers', name: 'users', component: UsersPage },
        { path: '/verkoopkanalen', name: 'sales-channels', component: SalesChannelsPage },
        { path: '/dropshipmentkanalen', name: 'dropshipment', component: DropshipmentPage },
        { path: '/settings', name: 'settings', component: SettingsPage },
        { path: '/rapportage/producten', name: 'report_products', component: ReportProductsPage },
        { path: '/rapportage/winstmarges', name: 'report_profit_margins', component: ReportProfitMargin },
        { path: '/rapportage/omzet', name: 'report_revenue', component: RevenueReportPage },
        // { path: '/producten/voorraadwaarde', name: 'stock_value', component: StockValuePage },
        { path: '/urenregistratie', name: 'hour_registration', component: HourRegistrationPage },
        { path: '/rapportage/inkoopwaarde/orders', name: 'report_purchasing_value_orders', component: PurchaseValuesOrders },
        // { path: '/voorraadmanagement', name: 'stock_management', component: StockManagementPage },
        { path: '/bestellijst', name: 'order_lists', component: OrderListPage },
        { path: '/producten/onbekend', name: 'unknown_products', component: UnknownProductsPage },
        // { path: '/kassa', name: 'checkout', component: CheckoutPage }
      ]
    }
  ],
  mode: 'history',
  linkExactActiveClass: 'active'
})

function rejectIfNotAuthenticated (to, from, next) {
  if (!auth.isAuthenticated()) {
    return next({ name: 'login', query: { session_expired: true } })
  }

  auth.loadUser().then(() => next())
}

function rejectIfAuthenticated (to, from, next) {
  if (auth.isAuthenticated()) {
    return next({ name: 'dashboard' })
  }
  return next()
}



// WEBPACK FOOTER //
// ./src/router.js